(function() {
    'use strict';

    angular
        .module('tmgApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('indicator-file', {
            parent: 'import',
            url: '/indicator-file?page&sort&search&agence&category&typeIntervention&imported&ignored&error',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'tmgApp.indicatorFile.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/indicator-file/indicator-files.html',
                    controller: 'IndicatorFileController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null,
                agence: null,
                category: null,
                typeIndicator: null,
                imported: null,
                ignored: null,
                error: null,
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search,
                        agence: $stateParams.agence,
                        category: $stateParams.category,
                        typeIndicator: $stateParams.typeIndicator,
                        imported: $stateParams.imported,
                        ignored: $stateParams.ignored,
                        error: $stateParams.error,
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('indicatorFile');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('indicator-file-detail', {
            parent: 'indicator-file',
            url: '/indicator-file/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'tmgApp.indicatorFile.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/indicator-file/indicator-file-detail.html',
                    controller: 'IndicatorFileDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('indicatorFile');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'IndicatorFile', function($stateParams, IndicatorFile) {
                    return IndicatorFile.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'indicator-file',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('indicator-file-detail.edit', {
            parent: 'indicator-file-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/indicator-file/indicator-file-dialog.html',
                    controller: 'IndicatorFileDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['IndicatorFile', function(IndicatorFile) {
                            return IndicatorFile.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('indicator-file.new', {
            parent: 'indicator-file',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/indicator-file/indicator-file-dialog.html',
                    controller: 'IndicatorFileDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                filename: null,
                                agence: null,
                                category: null,
                                typeIndicator: null,
                                csv: null,
                                imported: false,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('indicator-file', null, { reload: 'indicator-file' });
                }, function() {
                    $state.go('indicator-file');
                });
            }]
        })
        .state('indicator-file.edit', {
            parent: 'indicator-file',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/indicator-file/indicator-file-dialog.html',
                    controller: 'IndicatorFileDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['IndicatorFile', function(IndicatorFile) {
                            return IndicatorFile.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('indicator-file', null, { reload: 'indicator-file' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('indicator-file.delete', {
            parent: 'indicator-file',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/indicator-file/indicator-file-delete-dialog.html',
                    controller: 'IndicatorFileDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['IndicatorFile', function(IndicatorFile) {
                            return IndicatorFile.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('indicator-file', null, { reload: 'indicator-file' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
